// Utils
import cn from '../../../utils/cn';

// Styles
import styles from './GroupList.module.css';

/**
 * GroupList
 * @param {object} params
 * @param {string} params.label - Group label displayed above the list
 * @param {Array<any>} params.items - Items to iterate over
 * @param {(item: any) => import('react').ReactNode} params.children - Render function called for each item
 * @param {import('react').ReactNode} params.action - Action to display in the header
 * @returns {JSX.Element} GroupList component
 */
function GroupList({
  label, items, children, action,
}) {
  return (
    <div className={cn([styles.container, label && styles['container-with-label']])}>
      {label ? (
        <div className={styles.title}>
          {label}
          {action}
        </div>
      ) : null}
      <div className={styles.list}>
        {items?.map((item) => (
          <div key={item.id} className={styles.row}>
            {children(item)}
          </div>
        ))}
      </div>
    </div>
  );
}

export default GroupList;
